export default function Strengths() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 sm:py-24 lg:py-28 px-4 sm:px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 sm:mb-20">
          <div className="inline-block mb-5 sm:mb-7">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              Why Choose Us
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-5 sm:mb-7 leading-tight px-4">
            選ばれる理由
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-10">
          {/* 信頼感 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-10 hover:shadow-xl transition-all duration-300 border-t-4 border-[#d4af37]">
            <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-6 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full">
              <i className="ri-shield-star-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl lg:text-[22px] font-bold text-[#1e3a8a] mb-5 text-center lg:leading-relaxed">
              30年以上の<span className="text-[#d4af37] lg:text-[30px]">メディアキャリア</span>に裏打ちされた信頼
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              タレント 菊田あや子が持つ、長年のメディア露出と実績による信頼感が、ツアーの安心感と参加意欲を高めます。
            </p>
          </div>

          {/* ターゲット分析 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-10 hover:shadow-xl transition-all duration-300 border-t-4 border-[#d4af37]">
            <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-6 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full">
              <i className="ri-line-chart-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl lg:text-[22px] font-bold text-[#1e3a8a] mb-5 text-center lg:leading-relaxed">
              <span className="text-[#d4af37] lg:text-[30px]">インサイト</span>に基づく<br />ファンベース集客
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              50代以上の女性層に特化した行動<strong className="text-[#1e3a8a]">インサイト</strong>分析に基づき、一過性で終わらない<strong className="text-[#1e3a8a]">ファンベースの集客モデル</strong>を構築します。
            </p>
          </div>

          {/* 映像素材 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-10 hover:shadow-xl transition-all duration-300 border-t-4 border-[#d4af37]">
            <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-6 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full">
              <i className="ri-film-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl lg:text-[22px] font-bold text-[#1e3a8a] mb-5 text-center lg:leading-relaxed">
              継続的な<span className="text-[#d4af37] lg:text-[30px]">集客資産</span>となる<br className="lg:hidden" />高品質な映像提供
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              パンフレットやWebサイトの訴求力を劇的に高める二次利用可能な素材を納品します。
            </p>
          </div>
        </div>

        {/* お問い合わせボタン */}
        <div className="text-center mt-12 sm:mt-16">
          <button
            onClick={scrollToContact}
            className="bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </button>
        </div>
      </div>
    </section>
  );
}